import { default as i18n } from "i18next";
import { initReactI18next } from "react-i18next";
import translation from "../../locales/sv.json";
import detector from "i18next-browser-languagedetector";
import { AI_PRODUCT_NAME } from "src/common/branding";
import {
	preferenceStorageKey,
	readLocalPreference,
	writeLocalPreference,
} from "./localPreference.js";

const resources = {
	sv: {
		translation,
	},
} as const;

export interface Language {
	code: string;
	label: string;
}

export const LANGUAGES: Language[] = [
	{ code: "sv", label: "Svenska" },
	{ code: "en", label: "English" },
];

// preferences.language, once set, is the source of truth; detector only decides for first-time users.
const storedLanguage = readLocalPreference<string>(
	preferenceStorageKey("language"),
)?.value;
const supportedLngs = LANGUAGES.map((language) => language.code);
const initialLanguage =
	storedLanguage && supportedLngs.includes(storedLanguage)
		? storedLanguage
		: undefined;

i18n
	.use(detector)
	.use(initReactI18next)
	.init({
		...(initialLanguage ? { lng: initialLanguage } : {}),
		// Detector must not write: preferences.language owns persistence (it still reads for first-load detection).
		detection: { caches: [] },
		fallbackLng: "en",
		returnNull: false,
		interpolation: {
			escapeValue: false,
			defaultVariables: { aiProductName: AI_PRODUCT_NAME },
		},
		keySeparator: false,
		nsSeparator: false,
		resources,
		supportedLngs,
	})
	.then(() => {
		// One-time migration to a synced preference, stamped at the epoch so it never outranks a real remote write.
		if (!initialLanguage) {
			writeLocalPreference(
				preferenceStorageKey("language"),
				i18n.language,
				new Date(0).toISOString(),
			);
		}
	})
	.catch(console.error);

document.documentElement.setAttribute("lang", i18n.language);
i18n.on("languageChanged", (lang) => {
	document.documentElement.setAttribute("lang", lang);
});
